import React, { useMemo,useEffect,useState } from 'react';
import { Card } from 'react-bootstrap';

export default (props) => {
  console.log(props)
  const [isReport, setIsReport] = useState(false);
  const data = useMemo(
    () => props.api.getDisplayedRowAtIndex(props.rowIndex).data,
    []
  );
  useEffect(() => {
    const match = /\r|\n/.exec(props.data.content);
    console.log(match,props.data.content)
    if(match){
      setIsReport(true);
    }
  }, [props.data.content])
  
  return (
    <div
      className="custom-tooltip"
      style={{ backgroundColor:  'white' }}
    >
      <Card style={{ width: '18rem' }}>
      <Card.Body>
        <Card.Title>Message</Card.Title>
        <Card.Text>
          {isReport ? (
            <pre>{data.content}</pre>
          ): (
            <>
            <p>{data.content}</p>
            </>
          )}
          
        </Card.Text>
      </Card.Body>
    </Card>
      
    </div>
  );
};